import React, { createContext, useContext, useState } from 'react';

const HoverContext = createContext<{ isHovered: boolean }>(undefined);

export function Hover({ children }) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <HoverContext.Provider value={{ isHovered }}>
      {children({
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false)
      })}
    </HoverContext.Provider>
  );
}

Hover.Action = function HoverAction({ children }) {
  const ctx = useContext(HoverContext);
  if (ctx === undefined) {
    throw new Error('use Hover.action inside Hover');
  }

  return children({
    className: `${!ctx.isHovered && 'visibility-hidden'} cursor-pointer`
  });
};

export function useHoverAction() {
  const [isHovered, setIsHovered] = useState(false);

  return {
    containerProps: {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    },
    actionProps: {
      className: `${!isHovered && 'visibility-hidden'} cursor-pointer`
    }
  };
}
